import { Box, Flex, HStack } from "@chakra-ui/react"
import { UserProfile } from "./UserProfile"
import OrganizationSwitcher from "../organization/OrganizationSwitcherV2"

export const TopBar = ({ Chat }: { Chat?: React.ReactNode }) => {
  return (
    <Flex justify="space-between" align="center" pl={"4px"} pr={"6px"} height="100%">
      <HStack width="fit-content" gap={{ base: "10px", md: "23px" }}>
        {/* {Chat} */}
        <OrganizationSwitcher />
      </HStack>
      <Box width="fit-content"></Box>
      <HStack width="fit-content">
        <UserProfile />
      </HStack>
    </Flex>
  )
}
